<template>
  <gs-named-modal class="gs-refresh-controls gs-aff-modal" name="add-membership-modal" width="640px" max-width="640px" :title="isEditing === false ? $t('frontend_groovesell_add_membership') : $t('frontend_groovesell_edit_membership')">
    <div class="gs-aff-form">
      <p>Select the membership and access level to deliver to your buyers.</p>
      <label>{{ $t('frontend_groovesell_select_membership') }}
        <gs-name-select v-model="localpostMembershipId" size="full" :placeholder="$t('frontend_groovesell_select_membership')" :options="postMembershipOptions" @change="selectMembership($event)" />
      </label>
      <label>{{ $t('frontend_groovesell_select_access_level') }}
        <gs-name-select v-model="localpostMembershipAccessLevelId" size="full" :placeholder="$t('frontend_groovesell_select_access_level')" :options="postAccessLevelOptions" @change="selectAccessLevel" />
      </label>
    </div>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', 'add-membership-modal')">{{ $t('frontend_close') }}</gs-button>
      <gs-button v-if="isEditing == false" variant="primary" :disabled="!post_addbtn" @click="postdata != '' ? addMembershipField() : null">{{ $t('frontend_add') }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import "../../affiliate-workspace.css";
export default {
    props: {
        isEditing: {
            type: Boolean,
            required: true,
        },
        postMembershipId: {
            required: true,
        },
        post_memberships: {
            required: true,
        },
        postdata: {
            required: true,
        },
        post_access_levels: {
            required: true,
        },
        post_addbtn: {
            required: true,

        },
        postMembershipAccessLevelId: {
            required: true,
        },
        postaccesslevelmemberid: {
            type: Function,
            required: true
        },
        addMembershipField: {
            type: Function,
            required: true
        }


    },
    data() {
        return {
            localpostMembershipId: this.postMembershipId,
            localpost_access_levels: this.post_access_levels,
            localpostMembershipAccessLevelId: this.postMembershipAccessLevelId
        }
    },
    computed: {
        gdButtonVariant() {
            return this.post_addbtn ? 'primary' : 'base';
        },
        postMembershipOptions() {
            return this.post_memberships.map(membership => ({ value: membership.id, text: membership.name }));
        },
        postAccessLevelOptions() {
            return this.localpost_access_levels.map(accessLevel => ({ value: accessLevel.secret_key, text: accessLevel.name }));
        },
    },
    methods: {
        selectMembership() {
            this.emitData('postMembershipId', this.localpostMembershipId);
            this.localpostMembershipAccessLevelId = '';
            this.emitData('postMembershipAccessLevelId', '');
            const selectedPostMembership = this.post_memberships.find((ele) => {
                return ele.id === this.localpostMembershipId;
            });

            this.localpost_access_levels = selectedPostMembership ? selectedPostMembership.access_level : []
            this.emitData('post_addbtn', false);
            this.emitData('postdata', []);
            this.emitData('post_access_levels', this.localpost_access_levels);
        },
        selectAccessLevel(value) {
            this.emitData('postMembershipAccessLevelId', value);
            this.postaccesslevelmemberid(value);
        },
        emitData(key, value) {
            this.$emit('update-data', {
                key: key,
                value: value,
            })
        },

    }
}
</script>
